// extracted by mini-css-extract-plugin
export var readonly = "_hv-1";
export var star = "_hv-0";